import { render, staticRenderFns } from "./checkpopup.vue?vue&type=template&id=852ddc76&scoped=true&"
import script from "./checkpopup.vue?vue&type=script&lang=js&"
export * from "./checkpopup.vue?vue&type=script&lang=js&"
import style0 from "./checkpopup.vue?vue&type=style&index=0&id=852ddc76&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852ddc76",
  null
  
)

export default component.exports